import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import DomPage from './pages/DomPage';
import PretextPage from './pages/PretextPage';
import './App.css';

function Nav() {
  const loc = useLocation();
  return (
    <nav className="nav">
      <Link className={`nav-link ${loc.pathname === '/' ? 'active' : ''}`} to="/">
        📐 Traditional DOM
      </Link>
      <Link className={`nav-link ${loc.pathname === '/pretext' ? 'active' : ''}`} to="/pretext">
        ⚡ pretext Library
      </Link>
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <header className="header">
          <h1>Text Height Measurement: DOM vs pretext</h1>
          <p className="subtitle">Comparing two approaches to measuring multiline text height in the browser</p>
        </header>
        <Nav />
        <main className="main">
          <Routes>
            <Route path="/" element={<DomPage />} />
            <Route path="/pretext" element={<PretextPage />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
